import styled from "styled-components";

export const Wrapper = styled.div`
    border-radius:50px;
    border:2px solid #04aecb;
    width:250px;
    display: grid;
    grid-template-columns: minmax(40px, auto) 1fr 3fr;
    grid-template-rows: 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    align-items:center;
    padding:5px;
    button{
        border-radius:100%;
        width:40px;
        height:40px;
        background:#04aecb;
        border:none;
        color:white;
        font-size:12pt;
    }
        span{
        color:#04aecb;
        }
`;